
import { assessmentHasImagesOrComments } from '@/shared/helpers';
import globalConstants from '../../shared/globalConstants';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import TrailerAssessment from '../../types/TrailerAssessment';
import TrailerAssessmentType from '../../types/TrailerAssessmentType';
import TrailerDamageLayout from './TrailerDamageLayout.vue';

export default defineComponent({
    components: { TrailerDamageLayout },
    data(): {
        type: keyof TrailerAssessment;
        subTypes: {
            driverSide: string;
            passengerSide: string;
            frontSide: string;
            rearSide: string;
        };
        typeAssessment: TrailerAssessmentType | undefined;
    } {
        return {
            type: globalConstants.trailer.assessmentTypes
                .damage as keyof TrailerAssessment,
            subTypes: {
                driverSide:
                    globalConstants.trailer.assessmentTypes.subTypes.driverSide,
                passengerSide:
                    globalConstants.trailer.assessmentTypes.subTypes
                        .passengerSide,
                frontSide:
                    globalConstants.trailer.assessmentTypes.subTypes.frontSide,
                rearSide:
                    globalConstants.trailer.assessmentTypes.subTypes.rearSide,
            },
            typeAssessment: undefined,
        };
    },
    created(): void {
        if (this.trailerAssessment)
            this.typeAssessment = this.trailerAssessment?.[this.type];
    },
    computed: {
        ...mapGetters({ trailerAssessment: 'trailerAssessment' }),
        driverButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.driverSide
            )
                ? 'active'
                : '';
        },
        passengerButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.passengerSide
            )
                ? 'active'
                : '';
        },
        frontButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.frontSide
            )
                ? 'active'
                : '';
        },
        rearButton(): string {
            return assessmentHasImagesOrComments(
                this.typeAssessment as TrailerAssessmentType,
                this.subTypes.rearSide
            )
                ? 'active'
                : '';
        },
    },
    methods: {
        frontTapped(): void {
            this.$router.push({
                path: `damageAssessment/${this.subTypes.frontSide}`,
            });
        },
        rearTapped(): void {
            this.$router.push({
                path: `damageAssessment/${this.subTypes.rearSide}`,
            });
        },
        driverTapped(): void {
            this.$router.push({
                path: `damageAssessment/${this.subTypes.driverSide}`,
            });
        },
        passengerTapped(): void {
            this.$router.push({
                path: `damageAssessment/${this.subTypes.passengerSide}`,
            });
        },
    },
});
